import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaVideoUrlModel extends BaseModel {
  variables?: { [key: string]: string } | MetaVideoUrlVariables;
}

export interface MetaVideoUrlVariables {
  Link: string;
}

export class MetaVideoUrlInitVariables implements MetaVideoUrlVariables {
  Link = '';
}

export class MetaVideoUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaVideoUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}